/*
 * @Author: Gavin Chan
 * @Date: 2021-05-27 14:17:54
 * @LastEditors : Please set LastEditors
 * @LastEditTime: 2026-01-13 09:31:49
 * @FilePath     : \examinee_web\src\utils\enum.ts
 * @Descriptions: todo
 */
/**
 * @description: 请求结果集
 */
export enum ResultEnum {
  SUCCESS = 0,
  ERROR = -1,
  TIMEOUT = 10042,
  TYPE = "success"
}

/**
 * @description: 请求方法
 */
export enum RequestEnum {
  GET = "GET",
  POST = "POST",
  PATCH = "PATCH",
  PUT = "PUT",
  DELETE = "DELETE"
}

/**
 * @description: 考试类型
 */
export const ExamTypeEnum = {
  0: "公务员考试",
  1: "资格类考试",
  2: "事业单位考试"
};

export const ExamTypeTagColorEnum = {
  0: "orange",
  1: "green",
  2: "blue"
};

/**
 * @description:  常用的contentTyp类型
 */
export enum ContentTypeEnum {
  // json
  JSON = "application/json;charset=UTF-8",
  // json
  TEXT = "text/plain;charset=UTF-8",
  // form-data 一般配合qs
  FORM_URLENCODED = "application/x-www-form-urlencoded;charset=UTF-8",
  // form-data  上传
  FORM_DATA = "multipart/form-data;charset=UTF-8"
}

export enum RoleEnum {
  // 管理员
  ADMIN = "admin",

  // 普通用户
  NORMAL = "normal"
}
export enum ServiceGateWay {

  DICTIONARY = "ZhuoFan_Wb_DataDictionaryService_WebApi/api",
  FILEDINFO = "ZhuoFan_Wb_InformationItemService_WebApi/api",
  BASIC_SERVICE = "ZhuoFan_Wb_BasicService_WebApi/api",
  AUDITLOG = "ZhuoFan_Wb_AuditLogService_WebApi/api",
  DOCUMENT = "ZhuoFan_Wb_ArticleService_WebApi/api",
  TEMPLATE = "ZhuoFan_Wb_TemplateService_WebApi/api",
  ORGANIZATION = "ZhuoFan_Wb_OrganizationService_WebApi/api",
  SUBJECT = "ZhuoFan_Wb_SubjectService_WebApi/api",
  EXAM = "ZhuoFan_Wb_ExamManagementService_WebApi/api",
  ORDER = "ZhuoFan_Wb_OrderManagementService_WebApi/api",
  NEWORDER = "ZhuoFan_Wb_OrderService_WebApi/api",
  EXAMINEE = "ZhuoFan_Wb_ExamineeManagementService_WebApi/api",
  WORKFLOW = "ZhuoFan_Wb_WorkflowService_WebApi/api",
  GATEWAY = "apiGateway/api",
  AUTH = "connect/token",
  REGISTEREDUSER = "ZhuoFan_Wb_RegisteredUserService_WebApi/api",
  MESSAGE = "ZhuoFan_Wb_MessageService_WebApi/api",
  NOTIFICATIONMESSAGE = "ZhuoFan_Wb_NotificationMessageService_WebApi/api",
  SCOREEXAMINEE = "scoreExaminee_web/api",
  SCOREQUERYSERVICE = "ZhuoFan_Wb_ScoreQueryService_WebApi/api",
  AdmitCardService = "ZhuoFan_Wb_AdmitCardService_WebApi",
  ANNOUNCEMENTEXAMINEESERVICE = "ZhuoFan_Wb_AnnouncementService_WebApi/api",
  ExamineePrivateRegisterService = "ZhuoFan_Wb_ExamineePrivateRegisterService_WebApi/api",
  PHOTOAISERVICE = "ZhuoFan_Wb_PhotoAiService_WebApi/api",
  ExamineeScenarioService = "ZhuoFan_Wb_ScenarioService_WebApi/api",

  ZhuoFan_Wb_InformationItemService_WebApi = "ZhuoFan_Wb_InformationItemService_WebApi",
  ZhuoFan_Wb_RegisteredUserService_WebApi = "ZhuoFan_Wb_OAuthService_WebApi",
  ZhuoFan_Wb_OAuthService_WebApi = "ZhuoFan_Wb_OAuthService_WebApi",
  ZhuoFan_Wb_ScenarioService_WebApi = "ZhuoFan_Wb_ScenarioService_WebApi",
}

// 实名认证方式
export enum RealNameAuthentication {
  // 百度上传身份证认证
  BaiduOcrCard = "ZhuoFan.Wb.RegisteredUserService.Application.RealNameHanlder.BaiduOcrCard.RealNameAuthenticationBaiduOcrCard,ZhuoFan.Wb.RegisteredUserService.Application, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null",
  // 自主身份证认证
  Autonomy = "ZhuoFan.Wb.RegisteredUserService.Application.RealNameHanlder.Autonomy.AutonomyRealNameAuthentication,ZhuoFan.Wb.RegisteredUserService.Application, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null",
  // 湖南省政务网认证
  GovernmentAffairs = "ZhuoFan.Wb.RegisteredUserService.Application.RealNameHanlder.GovernmentAffairs.RealNameAuthenticationGovernmentAffairs,ZhuoFan.Wb.RegisteredUserService.Application, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null"
}

// 实名认证类型枚举
export enum CertificationTypeEnum {
  IdCard, // 身份证认证;
  Other, // 其他方式认证;
  GovernmentAffairs // 政务网认证;
}

// minio上传文件夹类型枚举
export enum folderType {
  //  头像 | 审核、减免材料 | 照片 | 身份证、其他证件 | 文本,文档 | 证件照 | 其他
  avatar = "avatar",
  material = "material",
  photo = "photo",
  identity = "identity",
  document = "document",
  certificate = "certificate",
  zip = "zip",
  others = "others"
}

// 系统服务范围
export enum systemModuleEnum {
  module_0 = 1,
  /**报名 */
  module_1 = 2,
  /**编排 */
  module_2 = 4,
  /**准考证打印 */
  module_3 = 8,
  /**成绩查询 */
  module_4 = 16,
  module_5 = 32,
  module_6 = 64,
  module_7 = 128,
  module_8 = 256,
  module_9 = 512,
  module_10 = 1024,
  module_11 = 2018,
  module_12 = 4096,
  module_13 = 8192,
  module_14 = 16384,
  module_15 = 32767
}

// 人像对比结果消息状态
export enum MessageStatusEnum {
  /**比对失败 */
  Fail = 0,
  /**比对成功 */
  Success = 1,
  /**比对错误 */
  Error = 2,
  /**识别中 */
  ScanCoding = 3,
  // 关闭识别
  End = 4
}

// 验证码类型
export enum VerificationCodeTypeEnum {
  /**随机验证码 */
  Random,
  /**滑块验证码 */
  Sild
}
